var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_83_41)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.87559 10.3111L1.03114 13.9555C1.00201 14.0888 1.00301 14.2268 1.03406 14.3596C1.06512 14.4924 1.12545 14.6166 1.21064 14.7231C1.29583 14.8296 1.40373 14.9157 1.52646 14.9751C1.6492 15.0346 1.78366 15.0658 1.92003 15.0667C1.98357 15.0731 2.0476 15.0731 2.11114 15.0667L5.77781 14.2222L12.8178 7.20888L8.88892 3.28888L1.87559 10.3111Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0311 3.69778L12.4089 1.07556C12.2365 0.904029 12.0032 0.807739 11.76 0.807739C11.5168 0.807739 11.2835 0.904029 11.1111 1.07556L9.65332 2.53333L13.5778 6.45778L15.0355 5C15.1209 4.91426 15.1884 4.81253 15.2344 4.70065C15.2803 4.58877 15.3038 4.46892 15.3034 4.34797C15.3029 4.22701 15.2787 4.10733 15.232 3.99576C15.1853 3.8842 15.117 3.78294 15.0311 3.69778Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_83_41"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.fb565b83dece9ed0447ec45a8cb290a3.svg";
export { ForwardRef as ReactComponent };